import { RemoveJudgeRubric } from './remove-judge-rubric';
import { CreateRubric } from './create-form';

export const actionValidator = (type, obj, handleClose) => {
  switch (type) {
    case 'RemoveJudgeRubric':
      return <RemoveJudgeRubric obj={obj} handleClose={handleClose} />;
    case 'CreateRubric':
      return <CreateRubric handleClose={handleClose} />;
    // case 'Create':
    //   return <CreateClubForm handleClose={handleClose} />;
    default:
      return null;
  }
};
